import { render, staticRenderFns } from "./FormControlFilesFileSize.vue?vue&type=template&id=377be750"
import script from "./FormControlFilesFileSize.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlFilesFileSize.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports